const initSelectSort = () => {
  const sortSelectElem = document.getElementById('sort-select') as HTMLInputElement;

  if (null === sortSelectElem) {
    return;
  }

  /*
     * @param {type} document queryString (document.location.search)
     * @param {type} key to update
     * @param {type} new value
     * @returns {String} Return query string with updated key
     */
  const updateQueryStringParameter = function(uri, key, value) {
    const re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
    const separator = uri.indexOf('?') !== -1 ? '&' : '?';

    if (uri.match(re)) {
      return uri.replace(re, '$1' + key + '=' + value + '$2');
    } else {
      return uri + separator + key + '=' + value;
    }
  };

  sortSelectElem.addEventListener('change', function () {
    // Reload current document with user's sort preference
    document.location.search = updateQueryStringParameter(document.location.search, this.name, this.value);
  });
};

export default initSelectSort;

